<template>
    <div class="container">
        <div class="row">
            <div class="col-12 offset-lg-2 col-lg-8 pt-5">
                <form @submit.prevent="base_submit('model', 'submit', null)">
                    <form-checkbox v-model="model.acknowledged"
                                   :disabled="processing"
                                   :label="message"
                                   :validator="v$.model.acknowledged"
                                   :errors="{required:t('tip')}"/>

                    <div class="text-center mt-3">
                        <button type="submit" class="btn btn-primary" :disabled="processing">
                            {{t('submit')}}
                            <spinner v-if="processing"/>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

    import useVuelidate from "@vuelidate/core";

    import mixin_view from "@/mixins/view";
    import {getSafeTargetUri} from "@/helpers/url";

    import PageMessage from "@/components/page/PageMessage";
    import Spinner from "@/components/Spinner";
    import FormCheckbox from "@/components/form/FormCheckbox.vue";

    export default {
        name: "ViewsAcknowledgement",
        mixins: [mixin_view],
        setup() {
            return {
                v$: useVuelidate()
            }
        },
        components: {
            FormCheckbox,
            Spinner,
            PageMessage
        },
        data() {

            return {
                t_path: "views.acknowledgement",
                processing: false,
                model: {
                    acknowledged: false
                },
                privacyPolicyUrl: process.env.VUE_APP_PRIVACY_LINK
                    ? process.env.VUE_APP_PRIVACY_LINK
                    : this.$router.resolve({name: "privacy"}).fullPath
            };
        },
        validations() {

            return {
                model: {
                    acknowledged: {
                        required: value => true === value,
                    }
                }
            }
        },
        computed: {
            message() {

                return this.t("message", {
                    privacyPolicyUrl: this.privacyPolicyUrl
                })
            },
        },
        methods: {
            submit() {

                this.processing = true;

                this.$store
                    .dispatch("user/setAcknowledgement", this.model.acknowledged)
                    .then(() => {
                        const targetUri = getSafeTargetUri(this.$route.query.targeturi);

                        if (targetUri) {

                            this.$router.push(this.$router.resolve(targetUri));
                        } else {

                            this.$router.push({name: "home"})
                        }
                    })
                    .finally(() => this.processing = false);
            }
        },

    }
</script>